import {TFunction} from "i18next";

/**
 * Map of backend Identity error codes to i18n keys
 */
const identityErrorMap: Record<string, string> = {
  invalid_username_or_password:
    "email_login.messages.invalidUsernameOrPassword",
  account_locked: "email_login.messages.accountLocked",
  invalid_client: "email_login.messages.invalidClient",
};

/**
 * Extract a meaningful, localized error message from an API error response.
 */
export function getIdentityErrorMessage(error: any, t: TFunction): string {
  try {
    const identityErrorStr = error?.data?.Errors?.IdentityError?.[0];
    if (identityErrorStr) {
      const identityError = JSON.parse(identityErrorStr);
      const code = identityError?.error_description;

      if (code && identityErrorMap[code]) {
        return t(identityErrorMap[code]);
      }
    }
  } catch (e) {
    console.warn("Error parsing IdentityError", e);
  }

  // fallback
  return t("email_login.messages.loginError");
}
